/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BusinessLabel
 */
export interface BusinessLabel {
    /**
     * 
     * @type {string}
     * @memberof BusinessLabel
     */
    key: string;
    /**
     * 
     * @type {string}
     * @memberof BusinessLabel
     */
    value: string;
}

/**
 * Check if a given object implements the BusinessLabel interface.
 */
export function instanceOfBusinessLabel(value: object): value is BusinessLabel {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('value' in value) || value['value'] === undefined) return false;
    return true;
}

export function BusinessLabelFromJSON(json: any): BusinessLabel {
    return BusinessLabelFromJSONTyped(json, false);
}

export function BusinessLabelFromJSONTyped(json: any, ignoreDiscriminator: boolean): BusinessLabel {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'value': json['value'],
    };
}

export function BusinessLabelToJSON(json: any): BusinessLabel {
    return BusinessLabelToJSONTyped(json, false);
}

export function BusinessLabelToJSONTyped(value?: BusinessLabel | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'value': value['value'],
    };
}

